<div>
  <mat-card appearance="outlined" style="padding: 10px">
    <span *ngIf="activity == '600301' && cmpHirType == '1'">
      <mat-chip-listbox>
        <mat-chip-option class="example-chip-list" appearance="fill" *ngFor="let file of files">
          <a
            href="javascript:void();"
            style="color: rgb(4, 4, 4); text-decoration: none"
            (click)="downloadFiles(file.value)"
            >{{ file.fileName }} - {{ file.value.fileName }}</a
          >
        </mat-chip-option>
      </mat-chip-listbox>
      <br /><br />
    </span>
    @if(!hideToggle){
    <div>
      <mat-slide-toggle
        class="example-margin"
        id="attachment-toggle"
        [checked]="checked"
        (toggleChange)="showAttachments = !showAttachments"
        >Attachment</mat-slide-toggle
      >
    </div>
  }

    <div *ngIf="showAttachments" style="margin-top: 10px" id="attachment">
      <mat-card-content>
        <mat-chip-listbox class="">
          <mat-chip-option class="chipStyle-Normal marR16" *ngFor="let file of editFileNameArray">
            <img
              src="assets/images/icons/default_icons/icon-close-mini.png"
              id="closeMiniIconEdit"
              class="chipIconRight"
              style="cursor: pointer"
              alt="iconCloseMini"
              (click)="removeEditParent($event, file.fileID)"
            />
            <a
              href="javascript:void();"
              style="color: black; text-decoration: none"
              (click)="downloadFile(file.fileID)"
            >
              {{ file.fileName }}
            </a>
          </mat-chip-option>
          <mat-chip-option class="chipStyle-Normal marR16" *ngFor="let file of fileNameArray">
            <img
              src="assets/images/icons/default_icons/icon-close-mini.png"
              id="closeMiniIconPa"
              class="chipIconRight"
              style="cursor: pointer"
              alt="iconCloseMini"
              (click)="removeParent($event, file)"
            />
            {{ file }}
          </mat-chip-option>
        </mat-chip-listbox>
      </mat-card-content>
      <hr *ngIf="!viemMode" />
      <button *ngIf="!viemMode" mat-flat-button class="Icon-Btn" (click)="openDialog()">
        <img
          class="add_attach"
          name="addAttachicon"
          alt="icon-add"
          src="assets/images/icons/purple_icons/icon-add-dark.png"
        />
        <span name="addAttachText">Attach New Files</span>
      </button>
    </div>
  </mat-card>
</div>
